<template>
    <div>
        <div 
            v-for="(section, s) in data"
            :key="'section1' + s">
            <div 
                v-if="section.type == 'imagebenner'"
                :class="'py-10 text-center ' + section.class_css"
                :id="section.id_css">
                <zTextSection :data="section" />
                <zImageBanner :data="section.components"/>

                <div
                    class="mt-10 text-center z-btn-link-section" 
                    v-if="section.link">
                    <v-btn
                        class="text-secondary px-10 font-weight-bold"
                        :href="section.link"
                        :rel="section.nofollow ? 'nofollow' : ''"
                        :target="section.new_tab ? '_blank' : ''">
                        {{ section.link_label }}
                    </v-btn>
                </div>
            </div>
        </div>
        <div class="container-max-1600">
            <v-row class="my-4">
                <v-col
                    md="9"
                    cols="12">
                    <div class="tw-mb-7">
                        <v-chip-group
                            class="px-0" 
                            mandatory
                            selected-class="text-primary"
                            v-model="selectCollection">
                            <v-chip
                                rounded
                                value=""
                                class="type-font-heading">
                                All
                            </v-chip>
                            <v-chip 
                                rounded
                                v-for="(collection, c) in collections"
                                :key="'collection' + c"
                                :value="collection.title"
                                class="type-font-heading">
                                {{ collection.title }}
                            </v-chip>
                        </v-chip-group>
                    </div>
                    <v-row>
                        <v-col 
                            md="6"
                            lg="4"
                            cols="12"
                            v-for="(item, p) in posts.data"
                            :key="'item' + p">
                            <Zpost 
                                :data="item" 
                                class="text-left"
                                :label="item.type">
                            </Zpost>
                        </v-col>
                    </v-row>
                    <v-pagination
                        v-if="posts.meta"
                        v-model="page"
                        :length="posts.meta.last_page"
                        :total-visible="5"
                        class="my-4">
                    </v-pagination>
                </v-col>
                <v-col
                    md="3"
                    cols="12">
                    <div>
                        <v-text-field
                            append-inner-icon="mdi-magnify"
                            density="compact"
                            label="Search"
                            variant="outlined"
                            hide-details
                            single-line
                            v-model="search">
                        </v-text-field>
                    </div>
                    <div 
                        class="tw-mt-5"
                        v-if="tags.length > 0">
                        <h3>Tags</h3>
                        <v-chip-group 
                            mandatory
                            selected-class="text-primary"
                            v-model="selectTag"
                            column
                            class="px-0">
                            <v-chip
                                rounded
                                value=""
                                class="type-font-heading">
                                All
                            </v-chip>
                            <v-chip 
                                rounded
                                v-for="(tag, c) in tags"
                                :key="'collection' + c"
                                :value="tag"
                                class="type-font-heading">
                                {{ tag }}
                            </v-chip>
                        </v-chip-group>
                    </div>

                    <div 
                        v-for="(section, s) in data"
                        :key="'section2' + s">
                        <div 
                            v-if="section.type == 'multicolumncard'"
                            :class="'py-10 ' + section.class_css"
                            :id="section.id_css">
                            <div>
                                <zTextSection :data="section" class="text-center"/>

                                <div>
                                    <zMultiColumnCard
                                        :data="section.components"
                                        :col="12" />
                                </div>


                                <div
                                    class="mt-10 text-center z-btn-link-section" 
                                    v-if="section.link">
                                    <v-btn
                                        class="text-secondary px-10 font-weight-bold"
                                        :href="section.link"
                                        :rel="section.nofollow ? 'nofollow' : ''"
                                        :target="section.new_tab ? '_blank' : ''">
                                        {{ section.link_label }}
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
        <div 
            v-for="(section, s) in data"
            :key="'section3' + s">
            <div 
                v-if="section.type == 'imageleftbenner'"
                :class="'py-10 ' + section.class_css"
                :id="section.id_css">
                <div class="container-max-1600">
                    <zTextSection :data="section" class="text-center"/>
                    <zImageLeftBanner :data="section"/>

                    <div
                        class="mt-10 text-center z-btn-link-section" 
                        v-if="section.link">
                        <v-btn
                            class="text-secondary px-10 font-weight-bold"
                            :href="section.link"
                            :rel="section.nofollow ? 'nofollow' : ''"
                            :target="section.new_tab ? '_blank' : ''">
                            {{ section.link_label }}
                        </v-btn>
                    </div>
                </div>
            </div>
            <div 
                v-if="section.component == 'imagerightbanner'"
                :class="'py-10 ' + section.class_css"
                :id="section.id_css">
                <zTextSection :data="section"  class="text-center"/>
                <zImageRightBanner :data="section"/>

                <div
                    class="mt-10 text-center z-btn-link-section" 
                    v-if="section.link">
                    <v-btn
                        class="text-secondary px-10 font-weight-bold"
                        :href="section.link"
                        :rel="section.nofollow ? 'nofollow' : ''"
                        :target="section.new_tab ? '_blank' : ''">
                        {{ section.link_label }}
                    </v-btn>
                </div>
            </div>
            <div 
                v-if="section.type == 'slideshow'"
                :class="'py-10 ' + section.class_css"
                :id="section.id_css">
                <zTextSection :data="section" />
                <div>
                    <zSlide
                        v-if="section.component == 'slideshow'"
                        :data="section.components"/>
                    <zSlide2
                        v-if="section.component == 'slideshow2'"
                        :data="section.components"/>
                </div>
            </div>
            <div 
                v-if="section.type == 'slideshow2'"
                :class="'py-10 ' + section.class_css"
                :id="section.id_css">
                <zTextSection :data="section" />
                <div>
                    <zSlide2
                        :data="section.components"/>
                </div>
            </div>
            <div 
                v-if="section.type == 'slideshowthumb'"
                :class="'py-10 ' + section.class_css"
                :id="section.id_css">
                <div class="container-max-1600">
                    <zTextSection :data="section" class="text-center"/>
                    <zSlideThumb :data="section.components"/>
                </div>
            </div>
            <div 
                v-if="section.type == 'text'"
                :class="'py-10 ' + section.class_css"
                :id="section.id_css">
                <div class="container-max-1600">
                    <zTextSection :data="section" class="text-center"/>
                    <zText :data="section.components"/>

                    <div
                        class="mt-10 text-center z-btn-link-section" 
                        v-if="section.link">
                        <v-btn
                            class="text-secondary px-10 font-weight-bold"
                            :href="section.link"
                            :rel="section.nofollow ? 'nofollow' : ''"
                            :target="section.new_tab ? '_blank' : ''">
                            {{ section.link_label }}
                        </v-btn>
                    </div>
                </div>
            </div>
            <div 
                v-if="section.type == 'product'"
                :class="'py-10 ' + section.class_css"
                :id="section.id_css">
                <div class="container-max-1600">
                    <zTextSection :data="section" class="text-center" />

                    <div>
                        <zCarouselProduct
                            :data="section.components" />
                    </div>

                    <div
                        class="mt-10 text-center z-btn-link-section" 
                        v-if="section.link">
                        <v-btn
                            class="text-secondary px-10 font-weight-bold"
                            :href="section.link"
                            :rel="section.nofollow ? 'nofollow' : ''"
                            :target="section.new_tab ? '_blank' : ''">
                            {{ section.link_label }}
                        </v-btn>
                    </div>
                </div>
            </div>
            <div 
                v-if="section.type == 'post'"
                :class="'py-10 ' + section.class_css"
                :id="section.id_css">
                <div class="container-max-1600">
                    <zTextSection :data="section" class="text-center" />

                    <div>
                        <zCarouselPost
                            :data="section.components" />
                    </div>

                    <div
                        class="mt-10 text-center z-btn-link-section" 
                        v-if="section.link">
                        <v-btn
                            class="text-secondary px-10 font-weight-bold"
                            :href="section.link"
                            :rel="section.nofollow ? 'nofollow' : ''"
                            :target="section.new_tab ? '_blank' : ''">
                            {{ section.link_label }}
                        </v-btn>
                    </div>
                </div>
            </div>
            <div 
                v-if="section.type == 'brand'"
                :class="'py-10 ' + section.class_css"
                :id="section.id_css">
                <div class="container-max-1600">
                    <zTextSection :data="section" class="text-center" />

                    <div>
                        <zCarouselBrand
                            :data="section.components" />
                    </div>

                    <div
                        class="mt-10 text-center z-btn-link-section" 
                        v-if="section.link">
                        <v-btn
                            class="text-secondary px-10 font-weight-bold"
                            :href="section.link"
                            :rel="section.nofollow ? 'nofollow' : ''"
                            :target="section.new_tab ? '_blank' : ''">
                            {{ section.link_label }}
                        </v-btn>
                    </div>
                </div>
            </div>
            <div 
                v-if="section.type == 'flashsale'"
                :class="'py-10 ' + section.class_css"
                :id="section.id_css">
                <div class="container-max-1600">
                    <zTextSection :data="section" class="text-center" />

                    <div>
                        <zCarouselFlashsale
                            v-if="section.component == 'flashsale'"
                            :data="section.components" />
                        
                        <zFlashsale
                            v-if="section.component == 'flashsale2'"
                            :data="section.components" />
                    </div>

                    <div
                        class="mt-10 text-center z-btn-link-section" 
                        v-if="section.link">
                        <v-btn
                            class="text-secondary px-10 font-weight-bold"
                            :href="section.link"
                            :rel="section.nofollow ? 'nofollow' : ''"
                            :target="section.new_tab ? '_blank' : ''">
                            {{ section.link_label }}
                        </v-btn>
                    </div>
                </div>
            </div>
            <div 
                v-if="section.type == 'promotion'"
                :class="'py-10 ' + section.class_css"
                :id="section.id_css">
                <div class="container-max-1600">
                    <zTextSection :data="section" class="text-center" />

                    <div>
                        <zCarouselPromotion
                            v-if="section.component == 'promotion'"
                            :data="section.components" />
                            
                        <zPromotion
                            v-if="section.component == 'promotion2'"
                            :data="section.components" />

                    </div>

                    <div
                        class="mt-10 text-center z-btn-link-section" 
                        v-if="section.link">
                        <v-btn
                            class="text-secondary px-10 font-weight-bold"
                            :href="section.link"
                            :rel="section.nofollow ? 'nofollow' : ''"
                            :target="section.new_tab ? '_blank' : ''">
                            {{ section.link_label }}
                        </v-btn>
                    </div>
                </div>
            </div>
            <div 
                v-if="section.type == 'newsletter'"
                :class="'py-10 tw-bg-[#2D3A4B] ' + section.class_css"
                :id="section.id_css">
                <div class="container-max-1600">
                    <zTextSection 
                        :data="section" 
                        class="text-center text-secondary" />
                    
                    <div>
                        <zNewsletter
                            :data="section.components" />
                    </div>

                    <div
                        class="mt-10 text-center z-btn-link-section" 
                        v-if="section.link">
                        <v-btn
                            class="text-secondary px-10 font-weight-bold"
                            :href="section.link"
                            :rel="section.nofollow ? 'nofollow' : ''"
                            :target="section.new_tab ? '_blank' : ''">
                            {{ section.link_label }}
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, watch } from 'vue'
    import Zpost from './zPost.vue'
    import api from '@/api'
    import { useRoute } from 'vue-router'
    import zTextSection from './zTextSection'
    import zImageBanner from './zImageBanner'
    import zImageLeftBanner from './zImageLeftBanner'
    import zImageRightBanner from './zImageRightBanner'
    import zSlide from './zSlide'
    import zSlide2 from './zSlide2'
    import zSlideThumb from './zSlideThumb'
    import zCarouselProduct from './zCarouselProduct'
    import zCarouselPost from './zCarouselPost'
    import zCarouselBrand from './zCarouselBrand'
    import zCarouselFlashsale from './zCarouselFlashsale'
    import zFlashsale from './zFlashsale'
    import zCarouselPromotion from './zCarouselPromotion'
    import zPromotion from './zPromotion'
    import zText from './zText'
    import zNewsletter from './zNewsletter'
    import zMultiColumnCard from './zMultiColumnCard.vue'

    const route = useRoute()

    const { data } = defineProps(['data'])

    const posts = ref([])

    const loading = ref(false)
    const page = ref(1)
    const search = ref('')
    const collections = ref([])
    const selectCollection = ref('')
    const selectTag = ref('')
    const sort = ref('')
    const tags = ref([])

    getItem()
    getCollection()
    getTag()

    if(route.query.collections){
        selectCollection.value = route.query.collections
        getItem()
    }
    if(route.query.tag){
        selectTag.value = route.query.tag
        getItem()
    }
    if(route.query.search){
        search.value = route.query.search
        getItem()
    }

    watch(page, (val) => {
        getItem()
    })
    watch(selectCollection, (val) => {
        getItem()
    })
    watch(selectTag, (val) => {
        getItem()
    })
    watch(sort, (val) => {
        getItem()
    })
    watch(search, (val) => {
        setTimeout(() => {
            getItem()
        }, 500)
    })

    function getParam(){
        const params = {
            collections: selectCollection.value,
            tag: selectTag.value,
            sort: sort.value,
            page: page.value,
            search: search.value,
        };

        const filteredParams = Object.fromEntries(
            Object.entries(params).filter(([key, value]) => value)
        );

        return new URLSearchParams(filteredParams).toString();
    }

    async function getCollection(){
        const resCollection = await api.get('posts/collection/post')
        collections.value = resCollection.data.data
    }

    async function getTag(){
        const resTag = await api.get('posts/tags/post')
        tags.value = resTag.data
    }

    async function getItem(){
        loading.value = true

        await api.get('posts/post/?' + getParam())
            .then((resp) => {
                loading.value = false    
                posts.value = resp.data
            })
            .catch((err) => {
                loading.value = false    
            })
    }
</script>